 <template>
  <div class="right">
    <!-- 右上 -->
    <RightTop @data="getCreditDataFn"></RightTop>

    <div class="rightCenter">
      <div class="centerTit">股本结构</div>
      <div class="centerCon">
        <div class="no">
          <span></span>
        </div>
        <div class="excel" @click="downloadTable()">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <el-table
          :data="majorList"
          :show-header="false"
          border
          size="mini"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column
            v-for="(item,index) in majorList[0]"
            :prop="index + ''"
            :width="index == 0 ? '238' : 138 "
            :fixed="index == 0 ? true : false "
            :label="item[index + '']"
            :key="index"
          ></el-table-column>
        </el-table>

        <!-- 手写表格 -->
        <!-- <div class="tabulationTitle">
          <table>
            <tr>
              <th>变动日期</th>
            </tr>
            <tr>
              <th>公告日期</th>
            </tr>
            <tr>
              <th>变动原因</th>
            </tr>
            <tr>
              <th>总股本</th>
            </tr>
            <tr>
              <th>流通股</th>
            </tr>
            <tr>
              <th>流通A股</th>
            </tr>
            <tr>
              <th>高管股</th>
            </tr>
            <tr>
              <th>限售A股</th>
            </tr>
            <tr>
              <th>流通B股</th>
            </tr>
            <tr>
              <th>限售B股</th>
            </tr>
            <tr>
              <th>流通H股</th>
            </tr>
            <tr>
              <th>国家股</th>
            </tr>
            <tr>
              <th>国有法人股</th>
            </tr>
            <tr>
              <th>境内法人股</th>
            </tr>
            <tr>
              <th>境内发起人股</th>
            </tr>
            <tr>
              <th>募集法人股</th>
            </tr>
            <tr>
              <th>一般法人股</th>
            </tr>
            <tr>
              <th>战略投资者持股</th>
            </tr>
            <tr>
              <th>基金持股</th>
            </tr>
            <tr>
              <th>转配股</th>
            </tr>
            <tr>
              <th>内部职工股</th>
            </tr>
            <tr>
              <th>优先股</th>
            </tr>
          </table>
        </div>-->
        <!-- <div class="con">
          <table v-if="majorList">
            <tr>
              <td v-for="(item,index) in majorList" :key="index">{{item.changeDate}}</td>
            </tr>
          </table>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import RightTop from "@/components/rightTop.vue";
export default {
  props: {},
  components: {
    RightTop
  },
  data() {
    return {
      stockCode: "",
      enterpriseCode: "",
      majorList: []
    };
  },
  computed: {},
  methods: {
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 0 || row.rowIndex == 0) {
        return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;";
      }
    },
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
      this.getCapitalStructureData();
    },
    // 获取表格数据
    getCapitalStructureData() {
      let stockCode = this.stockCode;
      let enterpriseCode = this.enterpriseCode;
      api.stockStructure(stockCode, enterpriseCode).then(res => {
        this.majorList = res.data;
        // console.log(this.majorList, 777777777);
      });
    },
    // 下载
    downloadTable() {
      this.download(
        window.baseUrl +
          "/capitalStructure/downCapitalStructureData?stockCode=" +
          this.stockCode +
          "&enterpriseCode=" +
          this.enterpriseCode
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        cursor: pointer;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
    }
// 表格调整
/deep/ .el-table--border td,
.el-table--border th {
  // border-right: 1px solid #dfdfdf;
  // border-top: 1px solid #dfdfdf;
  background: rgba(5, 43, 79, 1) !important;

  border: 1px solid #08396A !important;
  color: #DFECF7 !important;
}
    // 手写表格
    // .tabulation {
    //   width: 100%;
    //   height: auto;
    //   display: flex;
    //   justify-content: space-between;
    //   .tabulationTitle {
    //     width: 184px;
    //     table th {
    //       width: 184px;
    //       height: 40px;
    //       line-height: 40px;
    //       padding-left: 11px;
    //       vertical-align: middle;
    //       background-color: rgba(247, 247, 247, 1);
    //       border: 1px solid rgba(223, 223, 223, 1);
    //       border-right: 0px solid rgba(223, 223, 223, 1);
    //       font-size: 14px;
    //       font-weight: bold;
    //     }
    //   }
    //   .con {
    //     flex: 1;
    //     table {
    //       width: 100%;
    //     }
    //     table td {
    //       width: 16%;
    //       height: 40px;
    //       line-height: 40px;
    //       border: 1px solid #dfdfdf;
    //       padding-left: 11px;
    //       // text-align: center;
    //       vertical-align: middle;
    //     }
    //   }

    //   //   表格
    //   table {
    //     // margin: 0 auto;
    //   }
    // }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/stock/structure.vue